import React from "react";
import classNames from "./style.module.css";
import Typography from "../../../../components/ui/typography";


const events = [
  {
    title: "Kayıt Süresi",
    date: (
      <>
        19 Ekim 2026 Pazartesi saat 13.00 -
        <br />
        26 Şubat 2027 Cuma saat 23.59
      </>
    ),
  },
  {
    title: "Deneme Sınavı",
    explanations: ["Ayrıntılar ilerleyen zamanlarda belli olacaktır."],
    subtitle: "(İnternet üzerinden)",
    date: "19 Şubat 2027 Cuma - 26 Şubat 2027 Cuma",
    results: [
      {
        title:
          "Saat 13.00'te sınav açılacaktır. Sınav 26 Şubat 2027, Cuma günü saat 17.00'de sona erecektir. (Sonuç açıklanmayacaktır. Sınav ekranlarının tanıtımı için yapılacaktır.)",
      },
    ],
  },
  {
    title: "Takım Belirleme Sınavı",
    explanations: ["Ayrıntılar ilerleyen zamanlarda belli olacaktır."],
    subtitle: "(İnternet üzerinden)",
    date: "27 Şubat 2027 Cumartesi",
    time: "13.00-14.15",
  },
  {
    title: "İl Finalleri Sınavı",
    explanations: ["Ayrıntılar ilerleyen zamanlarda belli olacaktır."],
    subtitle: "(İnternet üzerinden)",
    date: "27 Mart 2027 Cumartesi",
    time: "13.00-14.15",
  },
  {
    title: "Bölge Finalleri Sınavı",
    explanations: ["Ayrıntılar ilerleyen zamanlarda belli olacaktır."],
    subtitle: "(İnternet üzerinden)",
    date: "17 Nisan 2027 Cumartesi",
    time: "13.00-14.15",
  },
  {
    title: "Türkiye Finalleri Sınavı",
    explanations: ["Ayrıntılar ilerleyen zamanlarda belli olacaktır."],
    subtitle: "(Ankara'da Yazılı Sınav)",
    date: "29 Mayıs 2027 Cumartesi",
    time: "",
  },
  {
    title: "Ödül Töreni",
    subtitle: "(Ankara'da Yapılacaktır.)",
    //date: "26 Haziran 2027 Cumartesi",
    //time: "13.00",
    explanations: ["Ayrıntılar ilerleyen zamanlarda belli olacaktır."],
  },

  // {
  //   title: "Düşünce Şenliği",
  //   subtitle: "(Zoom üzerinden yapılacaktır)",
  //   date: "7 Haziran 2023 Çarşamba",
  //   explanations: [
  //     "Düşünce şenliğine katılacak kişilere zoom davet linki e-posta ile gönderilmiştir.",
  //   ],
  // },
];

const Schedule = () => (
  <div className={classNames.schedule}>
    <Typography color="orange" size="bigger">
      Yarışma Takvimi
    </Typography>
    <div className={"card " + classNames.card}>
      <table style={{ width: "100%" }}>
        <tbody className={classNames.schedule_table}>
          {events.map((event, key) => (
            <tr key={key}>
              <td>
                <Typography
                  color="orange"
                  font="merel"
                  weight="bold"
                  className="inline"
                >
                  {event.title}
                </Typography>
                {event.subtitle && (
                  <Typography className="inline" color="grey" weight="normal">
                    {event.subtitle}
                  </Typography>
                )}

                {event.explanations?.map((e) => {
                  return (
                    <p
                      style={{ width: 700, fontSize: 20 }}
                      className={classNames.calendarExplanations}
                    >
                      {e}
                    </p>
                  );
                })}
              </td>
              <td>
                <Typography
                  color="white"
                  font="tadao"
                  weight="normal"
                  className="inline"
                >
                  {event.date}
                </Typography>
                {event.time && (
                  <Typography
                    className="inline"
                    color="grey"
                    weight="normal"
                    font="tadao"
                  >
                    {event.time}
                  </Typography>
                )}
                {event.results &&
                  event.results.map((result, key) => (
                    <Typography
                      className={classNames.result}
                      key={key}
                      colSpan="2"
                      color="orange"
                      font="merel"
                      size="small"
                      weight="normal"
                    >
                      {result.title}
                      <span className="white">{result.date}</span>
                      {result.time && (
                        <span className="grey"> {result.time}</span>
                      )}
                    </Typography>
                  ))}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default Schedule;
